import { Injectable } from '@angular/core';
import { InstalledApplication } from '@era/locations-sdk';
import { Store } from '@ngrx/store';
import { first, map, tap, withLatestFrom } from 'rxjs';
import { DeviceInstalledApplicationsStoreActions } from '../device-installed-applications-store';
import { LocationsRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';

@Injectable()
export class DeviceApplicationSyncStatusResolver {
  constructor(
    private readonly installedApplications: Store<InstalledApplication>,
    private readonly routeStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve() {
    return this.routeStore.select(LocationsRouterStoreSelectors.selectBrandId).pipe(
      withLatestFrom(this.routeStore.select(LocationsRouterStoreSelectors.selectLocationId)),
      tap(([brandId, locationId]) => {
        if (locationId !== null && locationId !== undefined)
          this.installedApplications.dispatch(
            DeviceInstalledApplicationsStoreActions.InstalledApplicationsResolverActions.installedApplicationsRequested(
              { brandId, locationId }
            )
          );
      }),

      map(() => true),
      first()
    );
  }
}
